import { render, staticRenderFns } from "./TemplateReportIkiForm.vue?vue&type=template&id=49fd91c5&"
import script from "./TemplateReportIkiForm.vue?vue&type=script&lang=js&"
export * from "./TemplateReportIkiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports